<template>
    <div class="detail">
        <div class="box1">
            <p>查外贸,就用海查查</p>
        </div>
        <div class="box2 box">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <router-link to="/home">首页</router-link>
                </el-breadcrumb-item>
                <el-breadcrumb-item>
                    <span>公司详情</span>
                </el-breadcrumb-item>
            </el-breadcrumb>
            <div class="list">
                <div class="box-l">
                    <div class="boxli">
                        <div class="company">
                            <p>{{ data.enterpriseName }}</p>
                            <span v-if="data.isCollect==1" @click="cancelFavor(0)"><img src="@/assets/img/star.png" alt="">已关注</span>
                            <span v-if="data.isCollect==0" @click="favor(1)"><img src="@/assets/img/star_empty.png" alt="">关注</span>
                        </div>
                        <div class="jieshao jieshao1">
                            <div class="xinxi">
                                <img src="@/assets/img/tibao.png" alt="" />
                                <p>贸易信息</p>
                                <div class="line"></div>
                            </div>
                            <div class="li">
                                <p>
                                    进出口类型：
                                    <span v-if="data.isExport == 1">进口</span>
                                    <span v-if="data.isImport == 1">出口</span>
                                </p>
                            </div>
                            <div class="li">
                                <p>
                                    出口国家：
                                    <span>{{ data.exportCountry }}</span>
                                </p>
                            </div>
                            <div class="li">
                                <p>
                                    报关港：
                                    <span>{{ data.customsPort }}</span>
                                </p>
                            </div>
                            <div class="li">
                                <p>
                                    品名：
                                    <span>{{ data.productName }}</span>
                                </p>
                            </div>
                            <div class="li" style="margin-top: 10px">
                                <p>
                                    <span>近期贸易</span>
                                </p>
                                <div class="fl fl1" v-if="data.recentTrading == 1">
                                    低贸易量
                                </div>
                                <div class="fl fl2" v-if="data.recentTrading == 2">
                                    中贸易量
                                </div>
                                <div class="fl fl3" v-if="data.recentTrading == 3">
                                    高贸易量
                                </div>
                            </div>
                        </div>
                        <div class="jieshao">
                            <div class="xinxi">
                                <img src="@/assets/img/dasha.png" alt="" />
                                <p>公司信息</p>
                                <div class="line"></div>
                            </div>
                            <div class="li">
                                <p>
                                    企业网站：
                                    <a style="text-decoration: none" v-if="data.internetSiteList == []" href="javascript:;">暂无</a>
                                    <a v-for="item in data.internetSiteList" :key="item" :href="[item]" target="_black">{{ item }}</a>
                                </p>
                            </div>
                            <div class="li">
                                <p>
                                    企业邮箱：
                                    <span v-for="item in data.emailList" :key="item.id">{{
                                        item
                                        }}</span>
                                </p>
                            </div>
                            <div class="li" style="padding-bottom: 39px">
                                <p>
                                    企业地址：
                                    <span>{{ data.address }}</span>
                                </p>
                            </div>
                        </div>
                        <div class="jieshao">
                            <div class="xinxi" style="padding-bottom: 20px">
                                <p style="padding: 0">联系方式</p>
                            </div>
                            <div class="lx">
                                <div class="lxr" v-for="item in data.telephoneList" :key="item.telephone">
                                    <img src="@/assets/img/touxiang.png" alt="" />
                                    <div class="txt">
                                        <p>{{ item.name }}</p>
                                        <p class="numb">{{ item.telephone }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="box-r" id="apperweima" :class="[{ apperweima: ewm == 1 }]" v-show="ewm == 1">
                    <img src="http://www.haichacha.net/wechat.jpg" alt="" />
                    <p>
                        下载
                        <a href="javascript:;">海查查app</a>，更多数据查阅
                    </p>
                </div>
            </div>
        </div>
        <conversation />
        <popup ref="popup"></popup>
    </div>
</template>

<script>
import popup from "@/components/Popup";
import Conversation from "@/components/Conversation";
import Utils from '@/assets/js/util.js';
import {
    Loading,
    MessageBox
} from "element-ui";
export default {
    components: {
        Conversation, popup
    },
    data() {
        return {
            data: '',
            ewm: 0,
            isshow: 0,
            lod: ""
        };
    },
    mounted() {
        this.getdatadetail(this.$route.query.id);
    },
    methods: {
        getdatadetail(id) {
            this.lod = Loading.service({
                lock: true,
                text: "加载中……",
                background: "rgba(0, 0, 0, 0.7)"
            });
            this.$http.get("app/enterprise/info/" + id).then(res => {
                this.lod.close();
                if (res.data.code == 0) {
                    this.data = res.data.data;
                } else if (res.data.code == 1) {
                    this.$refs.popup.isvipshow(2);
                }
            });
        },
        favor(state) {
            this.$http.get("/app/enterprise/follow/" + this.$route.query.id).then(res => {
                if (res.status == 200) {
                    this.data.isCollect = state;
                    Utils.$emit('getCollect',{index:this.$route.query.index,isCollect:state});
                }
            });
        },
        cancelFavor(state) {
            MessageBox.confirm("是否取消关注?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
                center: true
            })
                .then(() => {

                    this.favor(state);
                })
                .catch(() => { });
        },
        close() {
            this.$router.push("/home");
        }
    }
};
</script>

<style lang="less" scoped>
.detail {
    .box1 {
        width: 100vw;
        height: 120px;
        background: url("../../assets/img/detail.jpg") no-repeat center center;
        background-size: cover;
        display: flex;
        justify-content: center;
        align-items: center;

        p {
            font-size: 32px;
            letter-spacing: 5px;
            color: #ffffff;
            font-weight: 600;
        }
    }

    .box2 {
        width: 1200px;
        margin: 0 auto;
        padding-top: 20px;

        el-breadcrumb-item {
            a:hover {
                color: #2462f0;
            }
        }

        .list {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            margin-top: 18px;
            margin-bottom: 68px;
            position: relative;

            .box-l {
                width: 100%;
                background-color: #ffffff;
                box-shadow: 3px 1px 9px 0px rgba(5, 53, 10, 0.11);
                border-radius: 10px;
                padding: 50px 79px;

                .boxli {
                    .company {
                        padding-bottom: 40px;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        p {
                            font-size: 30px;
                            font-weight: 600;
                            color: #353535;
                        }
                        span {
                            cursor: pointer;
                            margin-top: 15px;
                            display: block;
                            text-align: center;
                            img {
                                display: inline-block;
                                vertical-align: middle;
                                margin-right: 5px;
                            }
                        }
                    }

                    .jieshao {
                        .xinxi {
                            width: 100%;
                            display: flex;
                            align-items: center;
                            overflow: hidden;
                            padding-bottom: 32px;

                            p {
                                font-size: 18px;
                                font-weight: 600;
                                color: #4c4c4c;
                                padding: 0 18px 0 10px;
                                white-space: nowrap;
                            }

                            .line {
                                width: calc(100% - 127px);
                                height: 1px;
                                background: #e5e5e5;
                            }
                        }

                        .li {
                            display: flex;
                            align-items: center;
                            padding-bottom: 10px;

                            p {
                                font-size: 14px;
                                color: #838383;
                                line-height: 24px;

                                span {
                                    color: #575757;
                                }

                                a {
                                    margin-right: 20px;
                                    color: #3571fa;
                                    text-decoration: underline;
                                }
                            }

                            .fl {
                                width: 118px;
                                height: 30px;
                                margin-left: 14px;
                                border-radius: 3px;
                                color: #fff;
                                text-align: center;
                                line-height: 30px;
                            }

                            .fl1 {
                                background: url("../../assets/img/hot.png")
                                    #648fff no-repeat 10px center;
                                background-size: 15px 15px;
                            }

                            .fl2 {
                                background: url("../../assets/img/hot.png")
                                    #ff9564 no-repeat 10px center;
                                background-size: 15px 15px;
                            }

                            .fl3 {
                                background: url("../../assets/img/hot.png")
                                    #ff7070 no-repeat 10px center;
                                background-size: 15px 15px;
                            }
                        }
                    }

                    .jieshao1 {
                        padding-bottom: 50px;
                    }

                    .lx {
                        display: flex;
                        // justify-content: space-between;
                        flex-wrap: wrap;
                        width: 100%;

                        .lxr {
                            // width: 220px;
                            padding: 20px;
                            // height: 80px;
                            background-color: #f8f8f8;
                            border-radius: 3px;
                            margin-bottom: 30px;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            margin: 0 20px 20px 0;

                            .txt {
                                width: 120px;
                                padding-left: 18px;

                                p {
                                    font-size: 16px;
                                    color: #393939;
                                    line-height: 26px;
                                    font-weight: 600;
                                }

                                .numb {
                                    width: 120px;
                                    font-weight: normal;
                                    color: #396ef3;
                                    white-space: normal;
                                    word-wrap: break-word;
                                }
                            }
                        }
                    }
                }
            }

            .box-r {
                width: 18%;
                box-shadow: 3px 1px 9px 0px rgba(5, 53, 108, 0.11);
                border-radius: 5px;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                height: 240px;

                img {
                    width: 85%;
                }

                p {
                    font-size: 12px;
                    color: #464646;
                    padding-top: 12px;

                    a {
                        color: #004ecf;
                    }
                }
            }

            #apperweima {
                width: 200px;
                height: 240px;
                background-color: #fff;
                padding: 0;
                position: absolute;
                right: 0px;
                top: 0px;
                box-shadow: 3px 1px 9px 0px rgba(5, 53, 108, 0.11);
                border-radius: 5px;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;

                img {
                    width: 85%;
                }

                p {
                    font-size: 12px;
                    color: #464646;
                    padding-top: 12px;

                    a {
                        color: #004ecf;
                    }
                }
            }

            .apperweima {
                position: fixed !important;
                top: 20px !important;
                right: 15vw !important;
            }
        }
    }
}

.isvip {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.5);

    .bg {
        width: 402px;
        height: 408px;
        overflow: hidden;

        .close {
            float: right;
        }

        .show {
            margin-top: 38px;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            align-items: center;

            .img1 {
                margin: 16px auto 20px;
            }

            .h1 {
                font-size: 26px;
                font-weight: 600;
                color: #483314;
                padding-bottom: 10px;
            }

            .h2 {
                font-size: 16px;
                color: #85593e;
            }

            .tq {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                width: 210px;

                p {
                    font-size: 14px;
                    color: #85593e;
                    padding-left: 10px;
                }
            }

            .tq1 {
                margin-top: 36px;
            }

            .tq2 {
                margin-top: 18px;
            }

            .start {
                margin: 70px 0 0;
                width: 257px;
                height: 48px;
                background-color: #f6d6b0;
                border-radius: 23px;
                display: block;
                font-size: 20px;
                font-weight: 600;
                color: #634824;
                text-align: center;
                line-height: 48px;
            }
        }

        .show2 {
            width: 352px;
            height: 369px;
            background: url("../../assets/img/show2.png") no-repeat center
                center;
            background-size: cover;
            border-radius: 20px;
            overflow: hidden;

            .h1 {
                color: #ffffff;
                margin-top: 44px;
            }

            .h2 {
                color: #ffffff;
            }

            .wx {
                width: 120px;
                margin-top: 50px;
            }

            .red {
                font-size: 18px;
                font-weight: 600;
                color: #ff4e00;
                padding: 10px 0;
            }

            .h5 {
                font-size: 14px;
                // line-height: 22px;
                letter-spacing: 1px;
                color: #999999;
            }
        }
    }
}
</style>
